import { Left } from 'fp-ts/Either';
import { type ErrorLeft, errorToLeft } from './errorToLeft';

export function enhancedErrorHandler(e: unknown): Left<ErrorLeft> {
  return errorToLeft(e, {
    parseValidation: true,
    preserveStringMessage: true,
    preserveErrorMessage: true,
  });
}
